module.exports = __webpack_public_path__ + "img/toggle-03-left.4d809a74.svg";